import { RSAA } from 'redux-api-middleware'

import { types, initialState } from './index'
import { contentfulEndpoint, getContentfulProxyHeaders } from './utils'

/**
 * Fetch prechecked provider categories from Contentful to be used in the Member
 * Communication Specialty dropdown
 *
 * @param {String} query The graphql query
 */
export const fetchMemberCommsPrecheckedCategories = query => {
  return {
    [RSAA]: {
      endpoint: contentfulEndpoint,
      method: 'POST',
      headers: getContentfulProxyHeaders(),
      body: JSON.stringify({ query }),
      types: [
        types.FETCH_MEMBER_COMMS_PRECHECKED_CATEGORIES_REQUEST,
        types.FETCH_MEMBER_COMMS_PRECHECKED_CATEGORIES_SUCCESS,
        types.FETCH_MEMBER_COMMS_PRECHECKED_CATEGORIES_ERROR,
      ],
      cache: true,
    },
  }
}

//-- Clear Contentful consts
export const clearMemberCommsPrecheckedCategories = () => ({
  type: types.CLEAR_MEMBER_COMMS_PRECHECKED_CATEGORIES,
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    // -- Generic Contentful store
    case types.FETCH_MEMBER_COMMS_PRECHECKED_CATEGORIES_REQUEST: {
      return {
        ...state,
        memberComms: {
          ...state.memberComms,
          busy: true,
          error: null,
        },
      }
    }

    case types.FETCH_MEMBER_COMMS_PRECHECKED_CATEGORIES_SUCCESS: {
      const { data } = payload
      return {
        ...state,
        memberComms: {
          ...state.memberComms,
          busy: false,
          entities: data,
        },
      }
    }

    case types.FETCH_MEMBER_COMMS_PRECHECKED_CATEGORIES_ERROR: {
      return {
        ...state,
        memberComms: {
          ...state.memberComms,
          busy: false,
          error: payload,
        },
      }
    }

    case types.CLEAR_MEMBER_COMMS_PRECHECKED_CATEGORIES: {
      return {
        ...state,
        memberComms: {
          ...state.memberComms,
          entities: initialState.memberComms.entities,
        },
      }
    }

    default:
      return state
  }
}
